import store from '@js/store'
export default [
    {
        path: 'properties',
        name: 'appUtilityProperty',
        redirect: { name: 'appUtilityPropertyList' },
        meta: { 
            title: 'utility.property.properties', 
            icon: 'fas fa-building',
            hideChildren: true,
            isNotNav: false,
            permissions: ['access-property']
        },
        beforeEnter: ((to, from, next) => {
            if( 0 && !store.getters['config/configs'].system.property) {
                next({ name: 'appDashboard'})
            } else {
                next()
            }
        }),
        component: {
            template: '<router-view></router-view>'
        },
        children: [
            {
                path: '',
                name: 'appUtilityPropertyList',
                meta: { 
                    trans: 'global.list',
                    title: 'utility.property.properties',
                },
                component: () => store.getters['user/roles']=='admin'?import('@views/app/utility/property/index'):import('@views/app/utility/property/index_user')/* webpackChunkName: "js/app/utility/property/index" */,
            },
            {
                path: 'add',
                name: 'appUtilityPropertyAdd',
                meta: { 
                    trans: 'global.add',
                    title: 'utility.property.property',
                    permissions:['access-config']
                },
                component: () => import('@views/app/utility/property/add' /* webpackChunkName: "js/app/utility/property/add" */),
            },
            {
                path: ':uuid/edit',
                name: 'appUtilityPropertyEdit',
                meta: { 
                    trans: 'global.edit',
                    title: 'utility.property.property',
                },
                component: () => import('@views/app/utility/property/edit' /* webpackChunkName: "js/app/utility/property/edit" */),
            },
            {
                path: ':uuid/edit_gallery',
                name: 'appUtilityPropertyEditGallery',
                meta: { 
                    trans: 'utility.property.props.featured_image',
                    title: 'utility.property.property',
                },
                component: () => import('@views/app/utility/property/edit_gallery' /* webpackChunkName: "js/app/utility/property/edit_gallery" */),
            },
            {
                path: ':uuid/calendar',
                name: 'appUtilityPropertyCalendar',
                meta: { 
                    trans: 'utility.property.calendar',
                    title: 'utility.property.property',
                },
                component: () => import('@views/app/utility/property/calendar' /* webpackChunkName: "js/app/utility/property/edit_gallery" */),
            },
            {
                path: ':uuid',
                name: 'appUtilityPropertyView',
                meta: { 
                    trans: 'global.view',
                    title: 'utility.property.property',
                },                
                component: () => store.getters['user/roles']=='admin'?import('@views/app/utility/property/view'):import('@views/app/utility/property/view_user')/* webpackChunkName: "js/app/utility/property/index" */,
            }
        ]
    },
]